import { generateUrlByQuery } from "@stadium/helpers/dom";

export const WALLET_URL = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/wallet/default`;
export const TEAMS_URL = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/teams`;
export const SHAERD_WALLET_ROUTE = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/wallet/[walletId]`;
export const WALLET_SUMMARY_ROUTE = `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/wallet/[walletId]/summary`;
export const WALLE_PAGE_ROUTE = WALLET_URL;
export const WALLET_ADD_FUNDS_URL = `${WALLE_PAGE_ROUTE}?add-funds=true`;
export const ALLOCATE_FUNDS_PARAM = "allocate-funds";

export const getSharedWalletUrl = (walletId, { showSummary = false } = {}) => {
  if (showSummary) {
    return WALLET_SUMMARY_ROUTE.replace("[walletId]", walletId);
  }
  if (walletId) {
    return SHAERD_WALLET_ROUTE.replace("[walletId]", walletId);
  }
  return WALLET_URL;
};

export const getSharedWalletAddFundsUrl = (teamId, { showSummary = false } = {}) => {
  if (teamId) {
    if (showSummary) {
      return generateUrlByQuery({
        pathname: WALLET_SUMMARY_ROUTE,
        query: { "add-funds": true, walletId: teamId },
      });
    }
    return generateUrlByQuery({
      pathname: SHAERD_WALLET_ROUTE,
      query: { "add-funds": true, walletId: teamId },
    });
  }
  return WALLET_ADD_FUNDS_URL;
};

export const getWalletAllocateFundsUrl = (teamId, { showSummary = false } = {}) => {
  if (teamId) {
    if (showSummary) {
      return generateUrlByQuery({
        pathname: WALLET_SUMMARY_ROUTE,
        query: { [ALLOCATE_FUNDS_PARAM]: true, walletId: teamId },
      });
    }
    return generateUrlByQuery({
      pathname: SHAERD_WALLET_ROUTE,
      query: { [ALLOCATE_FUNDS_PARAM]: true, walletId: teamId },
    });
  }
  return WALLET_ADD_FUNDS_URL;
};

export const getInviteOrAddUserReturnUrl = (teamId) => {
  if (teamId) {
    return generateUrlByQuery({
      pathname: SHAERD_WALLET_ROUTE,
      query: { walletId: teamId },
    });
  }
  return WALLET_URL;
};
